import React from "react"
import { graphql } from "gatsby"
import styled from "styled-components"

import Box from "components/atoms/Box"
import { colors } from "utils/styled-constants"

import LinkedInIconLight from "images/linkedin-icon-light.svg"
import TwitterIconLight from "images/twitter-icon-light.svg"
import WebsiteIconLight from "images/website-icon-light.svg"
import EmailIconLight from "images/email-icon-light.svg"

import LinkedInIconDark from "images/linkedin-icon-dark.svg"
import TwitterIconDark from "images/twitter-icon-dark.svg"
import WebsiteIconDark from "images/website-icon-dark.svg"
import EmailIconDark from "images/email-icon-dark.svg"

const SocialLinksWrapper = styled(Box)`
  display: flex;
  align-items: center;
  height: 30px;
  margin-top: 28px;
`
const StyledLink = styled.a`
  color: ${colors.lightBlue};
  transition: opacity 0.1s ease;
  display: block;
  margin-right: 12px;

  &:visited {
    color: ${colors.lightBlue};
  }
  &:hover {
    opacity: 0.5;
  }
`

const SocialLinks = ({
  linkedInLink,
  websiteLink,
  email,
  twitterLink,
  lightTheme,
}) => {
  const LinkedInIcon = lightTheme ? LinkedInIconLight : LinkedInIconDark
  const TwitterIcon = lightTheme ? TwitterIconLight : TwitterIconDark
  const WebsiteIcon = lightTheme ? WebsiteIconLight : WebsiteIconDark
  const EmailIcon = lightTheme ? EmailIconLight : EmailIconDark
  return (
    <SocialLinksWrapper pt={4}>
      {linkedInLink && (
        <span>
          <StyledLink
            href={linkedInLink}
            target="_blank"
            rel="noreferrer noopener"
          >
            <LinkedInIcon />
          </StyledLink>
        </span>
      )}
      {twitterLink && (
        <span>
          <StyledLink
            href={twitterLink}
            target="_blank"
            rel="noreferrer noopener"
          >
            <TwitterIcon />
          </StyledLink>
        </span>
      )}
      {websiteLink && (
        <span>
          <StyledLink
            href={websiteLink}
            target="_blank"
            rel="noreferrer noopener"
          >
            <WebsiteIcon />
          </StyledLink>
        </span>
      )}
      {email && (
        <span>
          <StyledLink href={`mailto:${email}`}>
            <EmailIcon />
          </StyledLink>
        </span>
      )}
    </SocialLinksWrapper>
  )
}

export default SocialLinks

export const query = graphql`
  fragment SocialLinks on ContentfulSocialLinks {
    linkedInLink
    websiteLink
    email
    twitterLink
  }
`
